import SiteTypes from "./site.types";
import { CountUpData } from "./site.utilize";

export const ChangeActiveLink = (activeKey) => ({
	type: SiteTypes.CHANGE_ACTIVE_LINK,
	payload: activeKey,
});

export const ToggleModalIos = () => ({
	type: SiteTypes.TOGGLE_MODAL_IOS,
});
export const ChangeProvince = (province) => ({
	type: SiteTypes.CHANGE_PROVINCE,
	payload: province,
});
export const SetCities = (cities) => ({
	type: SiteTypes.SET_CITIES,
	payload: cities,
});
export const SetLatLng = (latLng) => ({
	type: SiteTypes.SET_LATLNG,
	payload: latLng,
});
// export const SetAccessory = (accessory) => ({
// 	type: SiteTypes.SET_ACCESSORY,
// 	payload: accessory,
// });
export const SetAccessories = (Accessories) => ({
	type: SiteTypes.SET_ACCESSORIES,
	payload: Accessories,
});
export const SetProduct = (product) => ({
	type: SiteTypes.SET_PRODUCT,
	payload: product,
});
export const SetProducts = (Products) => ({
	type: SiteTypes.SET_PRODUCTS,
	payload: Products,
});
export const ToggleTecAttr = (tecAttr) => ({
	type: SiteTypes.TOGGLE_TEC_ATTR,
	payload: tecAttr,
});
export const SetInfo = (info) => ({
	type: SiteTypes.SET_INFO,
	payload: info,
});
export const SetAboutUs = (data) => ({
	type: SiteTypes.SET_ABOUT_US,
	payload: data,
});
export const SetBaseInfo = (data) => ({
	type: SiteTypes.SET_BASE_INFO,
	payload: data,
});
export const SetEducation = (data) => ({
	type: SiteTypes.SET_EDUCATION,
	payload: data,
});
export const SetCountUp = (data) => ({
	type: SiteTypes.SET_COUNT_UP,
	payload: CountUpData(data),
});
export const SetNearest = (threeData) => ({
	type: SiteTypes.SET_NEAREST,
	payload: threeData,
});
export const SetListProvince = (list) => ({
	type: SiteTypes.SET_LIST_PROVINCE,
	payload: list,
});
export const SetApplication = (application) => ({
	type: SiteTypes.SET_APPLICATION,
	payload: application,
});
export const SetNews = (news) => ({
	type: SiteTypes.SET_NEWS,
	payload: news,
});
export const SetSlider = (Sdata) => ({
	type: SiteTypes.SET_SLIDER,
	payload: Sdata,
});
export const SetTrackSystem = (TrackSis) => ({
	type: SiteTypes.SET_TRACK_SYS,
	payload: TrackSis,
});
